/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ApiError from '../model/ApiError';
import CommentReactionRequest from '../model/CommentReactionRequest';

/**
* JobCommentReaction service.
* @module api/JobCommentReactionApi
* @version V1
*/
export default class JobCommentReactionApi {

    /**
    * Constructs a new JobCommentReactionApi. 
    * @alias module:api/JobCommentReactionApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the addReaction operation.
     * @callback module:api/JobCommentReactionApi~addReactionCallback
     * @param {String} error Error message, if any.
     * @param {Object} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CommentReactionRequest} [commentReactionRequest] 
     * @param {module:api/JobCommentReactionApi~addReactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object}
     */
    addReaction(opts, callback) {
      opts = opts || {};
      let postBody = opts['commentReactionRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/comments/reactions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the removeReaction operation.
     * @callback module:api/JobCommentReactionApi~removeReactionCallback
     * @param {String} error Error message, if any.
     * @param {Object} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} reactionId 
     * @param {module:api/JobCommentReactionApi~removeReactionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object}
     */
    removeReaction(reactionId, callback) {
      let postBody = null;
      // verify the required parameter 'reactionId' is set
      if (reactionId === undefined || reactionId === null) {
        throw new Error("Missing the required parameter 'reactionId' when calling removeReaction");
      }

      let pathParams = {
        'reactionId': reactionId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/comments/reactions/{reactionId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
